// src/marketing/content/ContentCard.tsx — miroir de src/crm/pipeline/DealCard.tsx
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type { Content } from '../../lib/types'
import { KIND_LABELS, PLATFORM_LABELS, liveLabel } from './statuses'

interface ContentCardProps {
  content: Content
  onOpen: (contentId: string) => void
}

export function ContentCard({ content, onOpen }: ContentCardProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: content.id })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    background: 'var(--elevated)',
    border: '1px solid var(--line)',
    borderRadius: '8px',
    padding: '0.625rem 0.75rem',
    cursor: isDragging ? 'grabbing' : 'grab',
    userSelect: 'none',
    touchAction: 'none',
  }

  // DealCard n'a pas d'équivalent : le Pipeline n'ouvre aucune fiche depuis une carte.
  // Ici le clic est nécessaire (accès à la fiche contenu). Il est sûr parce que le
  // PointerSensor du board exige 5 px de mouvement avant de démarrer un drag ; dnd-kit
  // n'émet pas de click après un drag effectif.
  return (
    <div
      ref={setNodeRef}
      style={style}
      onClick={() => onOpen(content.id)}
      {...attributes}
      {...listeners}
    >
      <p style={{ margin: 0, fontSize: '0.8125rem', fontWeight: 500, color: 'var(--fg)', lineHeight: 1.35 }}>
        {content.title}
      </p>
      <p style={{ margin: '0.375rem 0 0', fontSize: '0.6875rem', color: 'var(--dim)' }}>
        {KIND_LABELS[content.kind]}
        {content.status === 'live' ? ` · ${liveLabel(content.kind)}` : ''} · {PLATFORM_LABELS[content.platform]}
        {content.plannedDate ? ` · ${content.plannedDate}` : ''}
        {content.budgetAllocated != null ? ` · ${content.budgetAllocated} €` : ''}
      </p>
    </div>
  )
}
